import { CHEMICAL_FIELDS_KEYS } from "./config";

import {
  CHINESE_CATEGORY_ALIASES,
  DEFAULT_CIP_CHEMICALS,
} from "../../constants/global.constants";

const getChemicalByName = (category, plantChemicalLibrary) => {
  const defaultChemName = DEFAULT_CIP_CHEMICALS[category].chemical_name;
  const chemInLibrary = plantChemicalLibrary.find(
    (chem) => chem.display_name === defaultChemName,
  );

  const { chem_id, display_name, price } = chemInLibrary || {};

  return {
    chem_id: chem_id || "",
    chemical_name: display_name || "",
    price: price || 0,
  };
};

export const getInitialChemicalSelection = (plantChemicalLibrary) => {
  const defaultChemicalSelection = {
    acid: getChemicalByName("ACID", plantChemicalLibrary),
    alkali: getChemicalByName("ALKALI", plantChemicalLibrary),
    additive_alkali: getChemicalByName("CIP_ADDITIVE", plantChemicalLibrary),
  };

  return defaultChemicalSelection;
};

const normalizeChemicalCategory = (category) => {
  if (!category) return "";
  const normalizedCategory = category.toLowerCase().trim();
  return CHINESE_CATEGORY_ALIASES[normalizedCategory] || normalizedCategory;
};

export const getChemicalOptionsByCategory = (chemicalLibrary) => {
  if (!chemicalLibrary || chemicalLibrary.length === 0) return {};
  const chemicalOptions = CHEMICAL_FIELDS_KEYS.reduce((acc, key) => {
    const sourceCategory = key === "additive_alkali" ? "cip_additive" : key;
    acc[key] = chemicalLibrary
      .filter(
        (item) => normalizeChemicalCategory(item.category) === sourceCategory,
      )
      .map((item) => ({
        label: item.display_name,
        value: item.display_name,
        price: item.price,
      }));
    return acc;
  }, {});
  return chemicalOptions;
};
